import { useState, useCallback } from 'react';
import flattenDeep from 'lodash/flattenDeep';
import { encodeSelections, decodeSelections } from '@/utils/widget/parseSelections';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
// const PREFIX =
//   'features: WidgetEdit: modals: SpreadsheetSelections: useHeaderSelections:';
// Manages spreadsheet header selections for interactive visualization.
// "Headers" refer to two types of selections:
// - Labels: Column titles (e.g., "Month", "Revenue") that describe each column.
// - Legends: Dataset titles (e.g., "2023 Sales", "2024 Sales") that identify different data series.
export default function useHeaderSelections(_ref) {
  let {
    initialLabelsSelections = '',
    initialLegendsSelections = ''
  } = _ref;
  const {
    0: updatedAt,
    1: setUpdatedAt
  } = useState(0); // Triggers publishable recalcuation

  const [labelsState, changeLabelsSelections] = useSelectionsState(initialLabelsSelections);
  const [legendsState, changeLegendsSelections] = useSelectionsState(initialLegendsSelections); // Wrap change handlers to update timestamp

  const handleChangeLabelsSelections = useCallback(cellRefs => {
    changeLabelsSelections(cellRefs);
    setUpdatedAt(Date.now());
  }, [changeLabelsSelections]);
  const handleChangeLegendsSelections = useCallback(cellRefs => {
    changeLegendsSelections(cellRefs);
    setUpdatedAt(Date.now());
  }, [changeLegendsSelections]);
  return {
    updatedAt,
    labelsSelections: labelsState,
    legendsSelections: legendsState,
    changeLabelsSelections: handleChangeLabelsSelections,
    changeLegendsSelections: handleChangeLegendsSelections
  };
}

function useSelectionsState() {
  let initialSelections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const {
    0: selections,
    1: setSelections
  } = useState(flattenDeep(decodeSelections(initialSelections))); // user facing

  const {
    0: publishableSelections,
    1: setPublishableSelections
  } = useState(initialSelections); // system
  // Pick the first and only label selection

  const activeSelectionCellRef = selections[0] || '';
  const changeSelections = useCallback(cellRefs => {
    const sheetIndex = spreadsheetCore.getSpreadsheetIndex(cellRefs);
    setSelections(currentSelections => {
      const [firstAddr, lastAddr] = spreadsheetCore.cellReferencesToAddress(cellRefs);
      if (!firstAddr) return currentSelections; // Ignore empty cell references
      // Create new selection with trimmed
      // excess cells removed from last address

      const selection = spreadsheetCore.prependSheetIndex(`${firstAddr.ref}${!lastAddr || firstAddr.ref === lastAddr.ref ? '' : `:${lastAddr.ref}`}`, sheetIndex);
      if (!selection) return currentSelections; // Ignore unsalvagable cell reference

      const publishableSelection = encodeSelections([selection]);
      setPublishableSelections(publishableSelection);
      return [selection];
    });
  }, []);
  return [{
    selections,
    publishableSelections,
    activeSelectionCellRef
  }, changeSelections];
}